import React, { useState, useEffect, useContext } from "react";
import "./Top_Destinations.css";
import { Col, Row } from "react-bootstrap";
import Yellow_BG_Btn from "../../common/common-btn/yellow-bg-btn/Yellow_BG_Btn";
import { useNavigate } from "react-router-dom";
import { getpackages } from "../../../utils/apis/packages/Homeapi";
import { Context } from "../../../utils/context";

const Top_Destinations = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  // detect screen resize
  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 992;
      setIsDesktop(desktop);

      // remove active state on mobile/tablet
      if (!desktop) {
        setActiveIndex(null);
      } else {
        setActiveIndex(0);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cards = [
    {
      title: "Express Leh-Ladakh",
      days: "(5 days)",
      image: "/assets/images/home/top_destinations/img-1.png",
    },
    {
      title: "Incredible Leh-Ladakh",
      days: "(6 days)",
      image: "/assets/images/home/top_destinations/img-2.png",
    },
    {
      title: "Leh-Ladakh Monasteries",
      days: "(7 days)",
      image: "/assets/images/home/top_destinations/img-1.png",
    },
    {
      title: "Classic Leh-Ladakh with Srinagar",
      days: "(7 days)",
      image: "/assets/images/home/top_destinations/img-2.png",
    },
  ];


  const {
    IMG_URL,
  } = useContext(Context);

  const [packages, setPackages] = useState();
  const getAllPackages = async () => {
    const res = await getpackages({ featured: true });

    if (res?.success) {
      setPackages(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllPackages();
  }, []);

  return (
    <section className="Top_Destinations">
      <div className="container">
        <div className="Top_Destinations_header">
          <h5 className="Top_Destinations_title">Top Destination</h5>

          <h2 className="Top_Destinations_subtitle">
            Our Featured Destination
          </h2>
        </div>

        <div className="expandable_section">
          <Row className="expandable_row mt-5">
            {packages?.map((card, index) => (
              <Col
                key={index}
                lg
                md={6}
                sm={6}
                xs={12}
                className={`expandable_col mb-4 ${isDesktop && activeIndex === index ? "active" : ""
                  }`}
                onClick={() => {
                  if (isDesktop) {
                    setActiveIndex(index);
                  }
                }}
              >
                <div
                  className="expandable_card"
                  style={{
                    backgroundImage: `url(${IMG_URL + card?.image})`,
                  }}
                >
                  <div className="card_overlay">
                    <h5 className="card_title">
                      {card.name || ""}
                      <br />

                      <span>{card?.days > 1 ? `${card?.days} Days` : `${card?.days} Day`}</span>
                    </h5>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="view_all_btn" onClick={() => navigate("/tour-packages")}>
          <Yellow_BG_Btn text={"VIEW MORE"} />
        </div>
      </div>
    </section>
  );
};

export default Top_Destinations;
